// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reporting-page {
  min-height: 80vh;
  overflow: auto;
}
.reporting-page .reporting-heading .mobile-heading {
  display: none;
}
@media (max-width: 1000px) {
  .reporting-page .reporting-heading {
    margin-bottom: 2vh;
  }
  .reporting-page .reporting-heading .mobile-heading {
    display: block;
  }
}
@media (max-width: 1000px) {
  .reporting-page .reporting-tab-container {
    display: none;
  }
}
.reporting-page .reporting-drawer-container {
  display: none;
  position: relative;
}
@media (max-width: 1000px) {
  .reporting-page .reporting-drawer-container {
    display: block;
  }
}
.reporting-page .reporting-drawer-container .drawer-btn {
  background-color: #151042;
  color: "#fff";
  margin: 0.5vh;
}
.reporting-page .reporting-drawer-container .drawer-btn:hover {
  background-color: #3b00f8;
}
.reporting-page .connected-devices-report,
.reporting-page .offline-devices-report {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 5vh;
}
.reporting-page .connected-devices-report .room-card,
.reporting-page .offline-devices-report .room-card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  background-color: #ffe169;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  color: #151042;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 5px;
  height: 200px;
  width: 300px;
}
.reporting-page .connected-devices-report .room-card:hover,
.reporting-page .offline-devices-report .room-card:hover {
  background-color: #151042;
  color: #ffe169;
}

.connected-devices-room-modal,
.offline-devices-room-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1000px;
  height: 60vh;
  max-height: 60vh;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 24;
  padding: 10px;
  overflow-y: auto;
}
@media (max-width: 1000px) {
  .connected-devices-room-modal,
  .offline-devices-room-modal {
    width: 92vw;
  }
}
.connected-devices-room-modal .room-header,
.offline-devices-room-modal .room-header {
  text-transform: uppercase;
  position: relative;
  margin: 0;
  border-top-left-radius: 5px;
}
.connected-devices-room-modal .device-header-information,
.offline-devices-room-modal .device-header-information {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
}
.connected-devices-room-modal .device-header-information .single-info,
.offline-devices-room-modal .device-header-information .single-info {
  width: 45%;
  background-color: #ffe169;
  padding: 10px;
  border-radius: 5px;
  color: #151042;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.connected-devices-room-modal .device-header-information .single-info h2,
.offline-devices-room-modal .device-header-information .single-info h2 {
  margin: 0;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
}
.connected-devices-room-modal .device-header-information .single-info p,
.offline-devices-room-modal .device-header-information .single-info p {
  font-weight: 700;
}
.connected-devices-room-modal .logs-header,
.offline-devices-room-modal .logs-header {
  display: none;
}
.connected-devices-room-modal .device-log-table-container .device-log-table,
.offline-devices-room-modal .device-log-table-container .device-log-table {
  width: 100%;
}
.connected-devices-room-modal .close-room-btn,
.offline-devices-room-modal .close-room-btn {
  width: 100%;
}
@media (max-width: 1000px) {
  .connected-devices-room-modal .device-header-information .single-info,
  .offline-devices-room-modal .device-header-information .single-info {
    width: 95%;
  }
  .connected-devices-room-modal .device-header-information .single-info h2,
  .offline-devices-room-modal .device-header-information .single-info h2 {
    font-size: 0.8rem;
  }
  .connected-devices-room-modal .device-header-information .single-info p,
  .offline-devices-room-modal .device-header-information .single-info p {
    font-weight: 500;
  }
  .connected-devices-room-modal .logs-header,
  .offline-devices-room-modal .logs-header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    margin-top: 2vh;
    position: relative;
  }
  .connected-devices-room-modal .device-log-table-container .connected-table td:nth-of-type(1):before,
  .offline-devices-room-modal .device-log-table-container .connected-table td:nth-of-type(1):before {
    content: "Log";
  }
  .connected-devices-room-modal .device-log-table-container .connected-table td:nth-of-type(2):before,
  .offline-devices-room-modal .device-log-table-container .connected-table td:nth-of-type(2):before {
    content: "Date/Time";
  }
  .connected-devices-room-modal .device-log-table-container .offline-table td:nth-of-type(1):before,
  .offline-devices-room-modal .device-log-table-container .offline-table td:nth-of-type(1):before {
    content: "Offline Time";
  }
  .connected-devices-room-modal .device-log-table-container .offline-table td:nth-of-type(2):before,
  .offline-devices-room-modal .device-log-table-container .offline-table td:nth-of-type(2):before {
    content: "Date/Time";
  }
  .connected-devices-room-modal .device-log-table-container .offline-table td:nth-of-type(2):before,
  .offline-devices-room-modal .device-log-table-container .offline-table td:nth-of-type(2):before {
    content: "Duration";
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/reporting.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;AADJ;AAIQ;EACI,aAAA;AAFZ;AAIQ;EAJJ;IAKQ,kBAAA;EADV;EAGU;IACI,cAAA;EADd;AACF;AAMQ;EADJ;IAEQ,aAAA;EAHV;AACF;AAMI;EACI,aAAA;EACA,kBAAA;AAJR;AAKQ;EAHJ;IAIQ,cAAA;EAFV;AACF;AAIQ;EACI,yBCrBO;EDsBP,aAAA;EACA,aAAA;AAFZ;AAGY;EACI,yBCxBD;ADuBf;AAMI;;ECbA,aAAA;EACA,uBAFkB;EAGlB,mBAHkC;EAIlC,mBAJsD;EAKtD,SALiE;EDiB7D,WAAA;EACA,eAAA;EACA,kBAAA;AAAR;AACQ;;ECnBJ,aAAA;EACA,uBAFkB;EAGlB,mBAHkC;EAIlC,mBAJsD;EAKtD,SALiE;EDsBzD,yBCnCK;EDoCL,2CAAA;EACA,cCxCO;EDyCP,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAMZ;AAJY;;EACI,yBChDG;EDiDH,cC9CC;ADqDjB;;AADA;;EC5BI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aD0BmB;ECzBnB,YDyB+B;ECxB/B,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;ADkCJ;ACjCI;EDgBJ;;ICfQ,WAAA;EDqCN;AACF;AAnBI;;EACI,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AAsBR;AAnBI;;ECjDA,aAAA;EACA,uBAFkB;EAGlB,mBAHkC;EAIlC,mBAJsD;EAKtD,SALiE;EDoD7D,eAAA;AA0BR;AAzBQ;;EACI,UAAA;EACA,yBCpEK;EDqEL,aAAA;EACA,kBAAA;EACA,cC1EO;ED2EP,2CAAA;AA4BZ;AA3BY;;EACI,SAAA;EACA,6CAAA;AA8BhB;AA5BY;;EACI,gBAAA;AA+BhB;AA3BI;;EACI,aAAA;AA8BR;AA1BQ;;EACI,WAAA;AA6BZ;AAzBI;;EACI,WAAA;AA4BR;AAzBI;EAEQ;;IACI,UAAA;EA2Bd;EA1Bc;;IACI,iBAAA;EA6BlB;EA3Bc;;IACI,gBAAA;EA8BlB;EA1BM;;IC9FJ,aAAA;IACA,uBAFkB;IAGlB,mBAHkC;IAIlC,mBAJsD;IAKtD,SALiE;IDiGzD,eAAA;IACA,kBAAA;EAiCV;EA5Bc;;IACI,cAAA;EA+BlB;EA7Bc;;IACI,oBAAA;EAgClB;EA3Bc;;IACI,uBAAA;EA8BlB;EA5Bc;;IACI,oBAAA;EA+BlB;EA7Bc;;IACI,mBAAA;EAgClB;AACF","sourcesContent":["@import \"../../variables.scss\";\n\n.reporting-page {\n    min-height: $main-height;\n    overflow: auto;\n\n    .reporting-heading {\n        .mobile-heading {\n            display: none;\n        }\n        @media (max-width: 1000px) {\n            margin-bottom: 2vh;\n\n            .mobile-heading {\n                display: block;\n            }\n        }\n    }\n\n    .reporting-tab-container {\n        @media (max-width: 1000px) {\n            display: none;\n        }\n    }\n\n    .reporting-drawer-container {\n        display: none;\n        position: relative;\n        @media (max-width: 1000px) {\n            display: block;\n        }\n\n        .drawer-btn {\n            background-color: $nitrocamDarkBlue;\n            color: \"#fff\";\n            margin: 0.5vh;\n            &:hover {\n                background-color: $nitrocamBlue;\n            }\n        }\n    }\n\n    .connected-devices-report,\n    .offline-devices-report {\n        @include flex();\n        width: 100%;\n        flex-wrap: wrap;\n        margin-bottom: 5vh;\n        .room-card {\n            @include flex();\n            background-color: $nitrocamYellow;\n            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n            color: $nitrocamDarkBlue;\n            text-transform: uppercase;\n            cursor: pointer;\n            border-radius: 5px;\n            height: 200px;\n            width: 300px;\n\n            &:hover {\n                background-color: $nitrocamDarkBlue;\n                color: $nitrocamYellow;\n            }\n        }\n    }\n}\n\n.connected-devices-room-modal,\n.offline-devices-room-modal {\n    @include modal($w: 1000px, $h: 60vh);\n\n    .room-header {\n        text-transform: uppercase;\n        position: relative;\n        margin: 0;\n        border-top-left-radius: 5px;\n    }\n\n    .device-header-information {\n        @include flex();\n        flex-wrap: wrap;\n        .single-info {\n            width: 45%;\n            background-color: $nitrocamYellow;\n            padding: 10px;\n            border-radius: 5px;\n            color: $nitrocamDarkBlue;\n            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n            h2 {\n                margin: 0;\n                box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n            }\n            p {\n                font-weight: 700;\n            }\n        }\n    }\n    .logs-header {\n        display: none;\n    }\n\n    .device-log-table-container {\n        .device-log-table {\n            width: 100%;\n        }\n    }\n\n    .close-room-btn {\n        width: 100%;\n    }\n\n    @media (max-width: 1000px) {\n        .device-header-information {\n            .single-info {\n                width: 95%;\n                h2 {\n                    font-size: 0.8rem;\n                }\n                p {\n                    font-weight: 500;\n                }\n            }\n        }\n        .logs-header {\n            @include flex();\n            margin-top: 2vh;\n            position: relative;\n        }\n\n        .device-log-table-container {\n            .connected-table {\n                td:nth-of-type(1):before {\n                    content: \"Log\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Date/Time\";\n                }\n            }\n\n            .offline-table {\n                td:nth-of-type(1):before {\n                    content: \"Offline Time\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Date/Time\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Duration\";\n                }\n            }\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
